import {Component} from '@angular/core';

@Component({
    selector:    'app-clear',
    templateUrl: './clear.component.html'
})

export class LayoutClearComponent {
}
